import { Button, Card, Descriptions } from "antd"
import { Address } from "components/Address"
import { clientMap } from "models/client"
import { IPolicyholder } from "platform-client/types"

const ClientCard = ({
  client,
  onEdit,
  onClear
}: IClientCardProps): JSX.Element => {
  return (
    <Card
      style={{ marginBottom: "15px" }}
      actions={[
        ...(typeof onEdit === "function"
          ? [
              <Button type="link" onClick={() => onEdit()}>
                Edit client details
              </Button>
            ]
          : []),
        ...(typeof onClear === "function"
          ? [
              <Button type="link" onClick={() => onClear()}>
                Clear
              </Button>
            ]
          : [])
      ]}
    >
      <Card.Meta
        style={{ marginBottom: "15px" }}
        title={client.legalName}
        description={clientMap[client.policyholderType]}
      />
      <Descriptions size="small" column={1}>
        {client.businessName && (
          <Descriptions.Item label="Business name">
            {client.businessName || ""}
          </Descriptions.Item>
        )}
        {client.contact.name.firstName && (
          <Descriptions.Item label="Contact name">
            {client.contact.name.firstName} {client.contact.name.lastName}
          </Descriptions.Item>
        )}
        {client.contact.phoneNumber && (
          <Descriptions.Item label="Phone number">
            {client.contact.phoneNumber}
          </Descriptions.Item>
        )}
        {client.contact.emailAddress && (
          <Descriptions.Item label="Email address">
            {client.contact.emailAddress}
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Contact address">
          <Address address={client.contactAddress} separator="," />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}

interface IClientCardProps {
  client: IPolicyholder
  onEdit?: () => void
  onClear?: () => void
}

export default ClientCard
